import React, { createContext, useContext } from 'react';
const SelectPlanCtx = /*#__PURE__*/createContext({});
export const SelectPlanProvider = _ref => {
  let {
    children,
    onSelectPlan
  } = _ref;
  const value = React.useMemo(() => ({
    onSelectPlan
  }), [onSelectPlan]);
  return /*#__PURE__*/React.createElement(SelectPlanCtx.Provider, {
    value: value
  }, children);
};
export const useSelectPlanContext = () => useContext(SelectPlanCtx);
//# sourceMappingURL=SelectPlanContext.js.map